import React from 'react'
import { useTranslation } from 'react-i18next'
import {observer} from 'mobx-react'
import {SendVerificationCode} from '@/components'

import styles from './styles.scss'

export type TwoFAConfirmProps = {
    onSubmit: (v) => void
    onCancel: () => void
}

export const TwoFAConfirm: React.FC<TwoFAConfirmProps> = observer(({onCancel, onSubmit}) => {
    const { t } = useTranslation()
    return (
        <SendVerificationCode
            cancelButtonText={t('TwoFAConfirm1.cancel')}
            submitButtonText={t('TwoFAConfirm1.submit')}
            onSubmit={onSubmit}
            onCancel={onCancel}
        />
    )
})
